
import Vue from 'vue';
/**
- Define rangeslider value thru props :setValue
**/
export default Vue.extend<any, any, any, any>({
  name: 'Rangeslider',
  model: {
    prop: 'setValue'
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set pointed value
     */
    setValue: {
      type: Number
    },
    /**
     * Set min value
     */
    minValue: {
      type: Number,
      default: 0
    },
    /**
     * Set max value
     */
    maxValue: {
      type: Number,
      default: 100
    },
    /**
     * Step / skip value when slide
     */
    step: {
      type: Number,
      default: 1,
      validator: stepValue => stepValue > 0
    },
    /**
     * Value list for Slider which don't have fixed increment.\n
     * It will ignore the `minValue`, `maxValue` and `step` if this props filled in.\n
     * Eg: Fibonacci [1, 2, 3, 5, 8, 13, 21, 34]
     */
    sliderValueList: {
      type: Array
    }
  },
  computed: {
    computedStyle() {
      let value = this.getNearestValue(this.setValue, this.setValue >= this.maxValue);
      if (this.sliderValueList) {
        value = this.sliderValueList.indexOf(this.setValue);
      }

      return `
        --min: ${this.minValueSlider};
        --max: ${this.maxValueSlider};
        --value: ${value};
      `;
    },
    minValueSlider() {
      if (this.sliderValueList) {
        return 0;
      }
      return this.minValue;
    },
    maxValueSlider() {
      if (this.sliderValueList) {
        return this.sliderValueList.length - 1;
      }
      return this.getNearestValue(this.maxValue, true);
    },
    stepSlider() {
      if (this.sliderValueList) {
        return 1;
      }
      return this.step;
    },
    valueSlider() {
      if (this.sliderValueList) {
        return this.sliderValueList.indexOf(this.setValue);
      }
      return this.setValue;
    }
  },
  methods: {
    updateValue(e: any) {
      const valueData = (e.target as HTMLInputElement).value;
      let result = Number(valueData);

      if (this.sliderValueList) {
        result = this.sliderValueList[result];
      } else if (result > this.maxValue) {
        result = this.maxValue;
      }
      /**
       * Method to input current number positioned on RangeSlider
       * @event input
       * @type {function}
       */
      this.$emit('input', result);
    },
    getNearestValue(value: number, ceil: boolean = false) {
      const positionFraction = (value - this.minValue) / this.step;
      const position = ceil ? Math.ceil(positionFraction) : Math.round(positionFraction);
      const result = position * this.step + this.minValue;
      if (result < this.minValue) {
        return this.minValue;
      }
      return result;
    }
  }
});
